import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M19.2 32.5c-.1 0-.3 0-.4-.1-4.1-1.5-6.9-5.5-6.9-9.9 0-5.8 4.7-10.6 10.6-10.6 3.1 0 6.1 1.4 8.1 3.7.4.5.4 1.3-.1 1.8s-1.3.4-1.8-.1a8.14 8.14 0 00-6.2-2.9c-4.4 0-8.1 3.6-8.1 8.1 0 3.4 2.1 6.4 5.3 7.6.6.2 1 1 .7 1.6-.2.5-.6.8-1.2.8z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M10.7 41.9l-.9-.3-6.3-6.3-.3-.5.3-1L6.2 31c-.5-1-.9-2-1.3-3H.6L0 27v-9.4l1-.6h3.9c.4-1 .8-2 1.3-3l-2.7-2.8-.3-.5.3-1 6.3-6.3.5-.3.9.3L14 6.3c1-.5 2-.9 3-1.3V.6l1-.6h9.4l.5 1v4c1.1.3 2.1.7 3.1 1.2l2.8-2.7.5-.3.9.3 6.3 6.3.3.5-.3.9-2.8 2.8c.5 1 .9 2 1.3 3h4.4l.5 1v9.4l-.9.6h-4c-.7 0-1.2-.6-1.2-1.2s.6-1.2 1.2-1.2h2.5v-6h-3.6l-.7-.3-.4-.7c-.4-1.4-.9-2.8-1.7-4.1l-.3-.6.4-.8 2.5-2.5-4.2-4.2L31.9 9l-1 .4-.5-.5c-1.2-.7-2.5-1.2-3.8-1.6h-1.1V2.5h-6v3.6l-.3.7-.7.4c-1.4.4-2.8.9-4.1 1.7l-.6.4-.8-.5-2.5-2.5-4.2 4.2 2.6 2.6.4 1-.4.5C8 15.8 7.5 17 7.1 18.4v1.1H2.5v6h3.6l.7.3.4.7c.4 1.4.9 2.8 1.7 4.1l.1.1.3.5-.5.8-2.5 2.5 4.2 4.2 2.6-2.6 1-.4.5.5c.7.4 1.4.7 2.1 1 .6.3 1 1 .7 1.6-.3.6-1 1-1.6.7-.6-.2-1.2-.5-1.7-.8l-2.8 2.7-.6.5zM1.3 26.7zM39 18.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M42.4 45H20.6c-.9 0-1.8-.5-2.3-1.3-.5-.8-.5-1.8 0-2.6l10.9-18.9c.5-.8 1.3-1.3 2.3-1.3.9 0 1.8.5 2.3 1.3l10.9 18.9c.5.8.5 1.8 0 2.6S43.3 45 42.4 45zm-11-21.6L20.5 42.3v.1c0 .1.1.1.1.1h21.8s.1 0 .1-.1v-.1L31.6 23.4h-.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M31.5 36.2c-.7 0-1.2-.6-1.2-1.2v-5.2c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2V35c0 .6-.5 1.2-1.2 1.2z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-fill-secondary",
			cx: 31.5,
			cy: 39.3,
			r: 1.3
		})
	]
});
export default SvgIcon;
